import { createFileRoute } from '@tanstack/react-router';
import { UserQuestionsChat } from '../../../components/Pleri/components/AboutUserQuestions';
import React from 'react';
import { SettingsLayout } from '../../../components/Pleri/components/Settings/SettingsLayout';

export const Route = createFileRoute('/settings/about-you/questions')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SettingsLayout>
      <UserQuestionsChat />
    </SettingsLayout>
  );
}
